import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import {
  MasonryDriverAction,
  useInvokeAction,
} from '@leagueplatform/masonry-renderers';
import { useGoBack } from '@leagueplatform/web-common';
import { useConfigProperty } from '@leagueplatform/core';
import { HeroBanner } from '../../../components/hero-banner/hero-banner.component';

export const NODE_TYPE_CHAT_HISTORY_HERO_BANNER = 'chatHistoryHeroBanner';

type ChatHistoryHeroBannerNodeProperties = {
  heading?: string;
  hideBackButton?: boolean;
};

type ChatHistoryHeroBannerNodeActions = {
  onBackButtonClick?: MasonryDriverAction;
};

type ChatHistoryHeroBannerNode = MasonryEngineNode<
  typeof NODE_TYPE_CHAT_HISTORY_HERO_BANNER,
  ChatHistoryHeroBannerNodeProperties,
  ChatHistoryHeroBannerNodeActions
>;

export type ChatHistoryHeroBannerRendererProps =
  MasonryEngineNodeRendererProps<ChatHistoryHeroBannerNode>;

export const ChatHistoryHeroBannerRenderer = ({
  heading,
  hideBackButton,
  onBackButtonClick,
  engineClassName,
  className,
  locatorId,
}: ChatHistoryHeroBannerRendererProps) => {
  const chatHistoryConfig = useConfigProperty('chatHistory');
  const fallbackLocation = chatHistoryConfig?.backButtonFallbackUrl;

  const goBack = useGoBack(fallbackLocation);
  const invokeAction = useInvokeAction();

  const handleBackButtonClick = React.useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      if (onBackButtonClick) {
        invokeAction({
          event,
          ...onBackButtonClick,
        });
      }
      goBack();
    },
    [goBack, invokeAction, onBackButtonClick],
  );

  return (
    <HeroBanner
      heading={heading}
      hideBackButton={hideBackButton}
      onBackButtonClick={handleBackButtonClick}
      className={[engineClassName, className].filter(Boolean).join(' ')}
      data-testid={locatorId}
    />
  );
};
